import styled from "styled-components";

const Wrapper = styled.div`
  margin: 2px 4px;
  white-space: nowrap;

  cursor: pointer;
  display: inline-block;
`;

export default Wrapper;
